module.exports = __webpack_public_path__ + "img/wifi.6698b400.svg";